<template>
  <svg class="icon" width="34" height="42" viewBox="0 0 34 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M33.0788 15.3814L18.4954 0.798003C17.6005 -0.0969055 16.1495 -0.0969055 15.2546 0.798003L0.671186 15.3814C-0.223727 16.2764 -0.223727 17.7273 0.671186 18.6222C1.5661 19.5171 3.01704 19.5171 3.91195 18.6222L14.5834 7.95071L14.5834 39.0834C14.5834 40.349 15.6094 41.375 16.875 41.375C18.1406 41.375 19.1666 40.349 19.1666 39.0834L19.1666 7.95071L29.8381 18.6222C30.733 19.5171 32.1839 19.5171 33.0788 18.6222C33.9737 17.7273 33.9737 16.2764 33.0788 15.3814Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconArrowTop'
}
</script>
